import styled from 'styled-components';

import {
    Radio,
    Spacer,
    token,
} from '@zillow/constellation';

export const StyledContainer = styled(Spacer)`
    border: 1px solid #D1D1D5;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;

    &:hover, &:active {
        background: ${token('colors.blue100')};
        border: 2px solid ${token('colors.blue400')};

        ${Radio} {
            border-color: ${token('colors.brand')}
        }
    }
`;
